import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { AssessmentService } from "../assessment.service";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Overlay } from "@angular/cdk/overlay";
import { SubmitConfirmationComponent } from "../../shared/components/submit-confirmation/submit-confirmation.component";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import Viewer from "viewerjs";

@Component({
  selector: "app-evaluate-assessment",
  standalone: false,
  templateUrl: "./evaluate-assessment.component.html",
  styleUrl: "./evaluate-assessment.component.css",
})
export class EvaluateAssessmentComponent {
  companyId: any;
  accessToken: any;
  assessmentDetails: any;
  searchText1: string = "";
  QuestionDetails: FormGroup;
  testReferenceId: any;
  sectionList: any[] = [];
  pageSize = 10;
  startIndex = 0;
  selectedQuestionId = 0;
  selectedQuestion: any;
  Questionremarks: string = "";
  QuestionList: any;
  selectedSection: any;
  selectedIndex = 0;
  assessmnetPaload: any;
  onSelectPagination: boolean = false;
  mediaAttachment: any[] = [];
  isAssessmentEmpty: boolean = false;
  isCandidatevalid: boolean = true;
  safeHtml!: SafeHtml;

  viewer!: Viewer;
  viewerContainer!: ElementRef;

  constructor(
    private assessmentService: AssessmentService,
    private toastrService: ToastrService,
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private overlay: Overlay,
    private sanitizer: DomSanitizer,
    private cd: ChangeDetectorRef
  ) {
    this.testReferenceId = this.route.snapshot.paramMap.get("id");

    this.accessToken = localStorage.getItem("accessToken");
    this.companyId = localStorage.getItem("companyId");

    this.QuestionDetails = this.fb.group({
      question: ["", Validators.required],
      answer: ["", Validators.required],
      score: ["", Validators.required],
      //  criteria: this.fb.array([]), // <== FormArray
    });
  }

  ngOnInit() {
    this.GetCandidateAssessment();
    this.selectedQuestionId = 0;
  }

  GetCandidateAssessment() {
    const payload = {
      candidateTestReferenceId: this.testReferenceId,
    };
    this.assessmentService
      .candidateSubmitData(payload, this.companyId, this.accessToken)
      .subscribe(
        (response) => {
          this.assessmentDetails = response.body;
          this.isCandidatevalid = true;

          this.isAssessmentEmpty = this.isAllSectionsEmpty(
            this.assessmentDetails.candidateEvaluationDetails
          );

          this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(
            this.assessmentDetails.candidateDetails.additionalInfo
          );

          this.QuestionList =
            this.assessmentDetails.candidateEvaluationDetails[0].sectionQuestionList;

          if (this.QuestionList?.length > 0) {
            this.onSelectQuestion(this.selectedQuestionId);
          }

          this.selectedSection =
            this.assessmentDetails.candidateEvaluationDetails[
              this.selectedIndex
            ].sectionName;

          let questionPayload = this.buildPayload(
            this.assessmentDetails.candidateEvaluationDetails
          );

          this.assessmnetPaload = {
            candidateTestRecordId: this.assessmentDetails.candidateTestRecordId,
            evaluationCompleted: false,
            adminScore: questionPayload,
          };
        },
        (error) => {
          this.isCandidatevalid = false;
          this.toastrService.error(error.error.message);
        }
      );
  }

  EvaluatorResponse() {
    this.assessmentService
      .EvaluatorResponse(
        this.assessmnetPaload,
        this.companyId,
        this.accessToken
      )
      .subscribe(
        (response) => {},
        (error) => {
          this.toastrService.error(error.error.message);
        }
      );
  }

  assessmentDashboard() {
    this.router.navigate(["assessment/list"]);
  }

  get visibleQuestions() {
    return this.QuestionList?.slice(
      this.startIndex,
      this.startIndex + this.pageSize
    );
  }

  next() {
    if (this.QuestionList?.length > 0) {
      if (!this.isScoreValid()) {
        return; // ⛔ stop execution
      }
      let QID = this.selectedQuestionId;
      this.updateQuestionpayload(QID);

      if (this.selectedQuestionId == this.QuestionList.length - 1) {
        this.onSectionChange(
          this.assessmentDetails.candidateEvaluationDetails[
            this.selectedIndex + 1
          ].sectionName
        );
      } else {
        this.selectedQuestionId = this.selectedQuestionId + 1;
        this.onSelectQuestion(this.selectedQuestionId);
        if (this.startIndex + this.pageSize < this.QuestionList.length) {
          this.startIndex++;
        }
      }
    } else {
      this.onSectionChange(
        this.assessmentDetails.candidateEvaluationDetails[
          this.selectedIndex + 1
        ].sectionName
      );
    }
  }

  prev() {
    if (this.QuestionList?.length > 0) {
      if (!this.isScoreValid()) {
        return; // ⛔ stop execution
      }
      let QID = this.selectedQuestionId;
      this.updateQuestionpayload(QID);
      if (this.selectedQuestionId == 0) {
        this.onSectionChange(
          this.assessmentDetails.candidateEvaluationDetails[
            this.selectedIndex - 1
          ].sectionName
        );
      } else {
        this.selectedQuestionId = this.selectedQuestionId - 1;
        this.onSelectQuestion(this.selectedQuestionId);
        if (this.startIndex > 0) {
          this.startIndex--;
        }
      }
    } else {
      this.onSectionChange(
        this.assessmentDetails.candidateEvaluationDetails[
          this.selectedIndex - 1
        ].sectionName
      );
    }
  }
  updateValue() {
    // let QID = this.selectedQuestionId;
    // this.updateQuestionpayload(QID);
  }
  onSelectQuestion(id: any) {
    console.log("select question");

    this.selectedQuestionId = id;
    this.selectedQuestion = this.QuestionList[id];

    this.Questionremarks = this.selectedQuestion?.evaluatorRemark;

    console.log("selectedQuestion", this.selectedQuestion);
  }

  onSelectQuestionPage(id: any) {
    if (!this.isScoreValid()) {
      return; // ⛔ stop execution
    }

    this.updateQuestionpayload(this.selectedQuestionId);
    // ✅ now switch to new question
    this.selectedQuestionId = id;
    this.selectedQuestion = this.QuestionList[id];

    this.Questionremarks = this.selectedQuestion?.evaluatorRemark;
  }

  setScore(rubric, Criteraia, Score, event: any) {
    this.selectedQuestion.rubricDetails[rubric].criteria[Criteraia].scoreGiven =
      Score;
  }

  getStatusClass(q: any) {
    return {
      selected: q.id == this.selectedQuestionId,
      answered: q.complete,
      inprogres: q.inprogres,
    };
  }

  backButton() {
    if (this.QuestionList?.length > 0) {
      if (!this.isScoreValid()) {
        return; // ⛔ stop execution
      }
      let QID = this.selectedQuestionId;
      this.updateQuestionpayload(QID);
    }

    this.router.navigate([
      "assessment/batch-candidates",
      this.assessmentDetails.linkId,
    ]);
  }

  onSectionChangeView(event: any) {
    if (this.QuestionList?.length > 0) {
      if (!this.isScoreValid()) {
        return; // ⛔ stop execution
      }
      let QID = this.selectedQuestionId;
      this.updateQuestionpayload(QID);
    }
    this.onSectionChange(event);
  }

  onSectionChange(event: any) {
    let sectionName = event;

    let selectedSec = this.assessmentDetails.candidateEvaluationDetails.find(
      (item) => item.sectionName == sectionName
    );

    this.selectedSection = event;

    this.selectedIndex =
      this.assessmentDetails.candidateEvaluationDetails.findIndex(
        (item) => item.sectionName === sectionName
      );

    console.log("selectedIndex", this.selectedIndex);

    this.QuestionList =
      this.assessmentDetails.candidateEvaluationDetails[
        this.selectedIndex
      ].sectionQuestionList;

    // this.QuestionList = selectedSec.sectionQuestionList;

    if (this.QuestionList?.length > 0) {
      this.selectedQuestionId = 0;
      this.selectedQuestion = this.QuestionList[this.selectedQuestionId];
      setTimeout(() => {
        this.initViewer();
      }, 0);
      this.Questionremarks = this.selectedQuestion.evaluatorRemark;
    }
  }

  addRemarks() {
    this.QuestionList[this.selectedQuestionId].evaluatorRemark =
      this.Questionremarks;
  }

  getAnsweredCount(criteria: any[]): number {
    return criteria.filter((item) => item.scoreGiven !== "").length;
  }

  getAnsweredRubricCount(): number {
    return this.selectedQuestion.rubricDetails.filter((rubric) =>
      rubric.criteria.every((c) => c.scoreGiven !== "" && c.scoreGiven != null)
    ).length;
  }

  buildPayload(sections: any[]) {
    return sections.flatMap((section: any) =>
      section.sectionQuestionList.map((question: any) => ({
        questionId: question.questionId,
        evaluatorRemark: question.evaluatorRemark || "",
        score: question.adminScore ?? " ",
        rubricBasedScore: question.rubricDetails.map((rubric) => ({
          rubricId: rubric.rubricId,
          criteriaScores: rubric.criteria.map((c) =>
            String(c.scoreGiven ?? "")
          ),
        })),
        isMarkedForReview: !!question.isMarkedForReview,
        isMarkedAsEvaluated: !!question.isMarkedAsEvaluated,
      }))
    );
  }

  updateQuestionpayload(Qd: any) {
    const questionId = this.selectedQuestion?.questionId;

    const existing = this.assessmnetPaload.adminScore.find(
      (q: any) => q.questionId === questionId
    );

    if (!existing) return;

    existing.evaluatorRemark = this.selectedQuestion.evaluatorRemark || "";

    if (this.selectedQuestion.rubricDetails.length > 0) {
      existing.rubricBasedScore = this.selectedQuestion.rubricDetails.map(
        (rubric) => ({
          rubricId: rubric.rubricId,
          criteriaScores: rubric.criteria.map((c) =>
            String(c.scoreGiven ?? "")
          ),
        })
      );
      existing.score = "";
    } else {
      existing.score = this.selectedQuestion.adminScore;
      existing.rubricBasedScore = [];
    }

    existing.isMarkedForReview = !!this.selectedQuestion.isMarkedForReview;
    existing.isMarkedAsEvaluated = !!this.selectedQuestion.isMarkedAsEvaluated;

    this.EvaluatorResponse();
  }

  completeEvaluation() {
    if (
      this.selectedQuestion.adminScore &&
      this.selectedQuestion.adminScore > this.selectedQuestion.score
    ) {
      this.toastrService.warning(
        `Max score is ${this.selectedQuestion.score}`,
        "Warning"
      );
      return;
    }

    this.updateQuestionpayload(this.selectedQuestion?.questionId);

    let result = this.assessmnetPaload.adminScore.every(
      (item) => item.isMarkedAsEvaluated && !item.isMarkedForReview
    );

    if (result) {
      this.SubmitConfirmation();
    } else {
      this.toastrService.warning(
        "Please Mark as Evaluated all questions and clear all Mark for Review before proceeding",
        "warning  "
      );
    }
  }

  getQuestionClass(question: any, index: number): string {
    const isSelected =
      this.selectedQuestion?.questionId === question.questionId;

    if (isSelected) return "selected";

    if (question.isMarkedAsEvaluated) return "answered";

    if (question.isMarkedForReview) return "inprogress";

    return "";
  }

  cleanHtml(html: string): string {
    return html.replace(/<\/span>/g, "");
  }

  openUrl(doc) {
    window.open(doc.fileLocation, "_blank");
  }

  onReviewChange() {
    if (this.selectedQuestion.isMarkedForReview) {
      this.selectedQuestion.isMarkedAsEvaluated = false;
    }
  }

  onEvaluatedChange() {
    if (this.selectedQuestion.isMarkedAsEvaluated) {
      this.selectedQuestion.isMarkedForReview = false;
    }
  }

  isScoreValid(): boolean {
    if (
      this.selectedQuestion.adminScore &&
      this.selectedQuestion.adminScore > this.selectedQuestion.score
    ) {
      this.toastrService.warning(
        `Max score is ${this.selectedQuestion.score}`,
        "Warning"
      );
      return false; // ❌ invalid
    }

    return true; // ✅ valid
  }

  SubmitConfirmation() {
    const dialogRef = this.dialog.open(SubmitConfirmationComponent, {
      width: "500px",
      hasBackdrop: true,
      restoreFocus: false,
      disableClose: true,
      scrollStrategy: this.overlay.scrollStrategies.noop(), // ⭐ KEY FIX
      data: {
        title: "Re-evaluate",
        message: "Are you sure you want to re-evaluate this assessment stage?",
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.router.navigate([
          "assessment/batch-candidates",
          this.assessmentDetails.linkId,
        ]);
      } else {
      }
    });

    // Access component instance
    dialogRef.componentInstance.dataChanged.subscribe((data: any) => {
      this.assessmnetPaload.evaluationCompleted = true;
      this.assessmentService
        .EvaluatorResponse(
          this.assessmnetPaload,
          this.companyId,
          this.accessToken
        )
        .subscribe(
          (response) => {
            dialogRef.componentInstance.handleStatus("Completed");
          },
          (error) => {
            this.toastrService.error(error.error.message);
          }
        );

      // update parent UI here
    });
  }

  isAllSectionsEmpty(details: any[]): boolean {
    return details.every(
      (section) =>
        !section.sectionQuestionList || section.sectionQuestionList.length === 0
    );
  }

  // implenent image preview
  @ViewChild("viewerContainer")
  set viewerSetter(element: ElementRef) {
    if (element) {
      this.viewerContainer = element;

      // wait for images to render
      setTimeout(() => {
        this.initViewer();
      }, 100);
    }
  }

  initViewer() {
    if (!this.viewerContainer) return;

    const images = this.viewerContainer.nativeElement.querySelectorAll("img");

    console.log("Images found:", images.length);

    if (images.length === 0) return;

    if (this.viewer) {
      this.viewer.destroy();
    }

    this.viewer = new Viewer(this.viewerContainer.nativeElement, {
      inline: false,
      navbar: true,
      toolbar: false,
      title: false,
    });
  }
}
